import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Constants } from "../../config/constants";

@Injectable({
  providedIn: 'root'
})
export class LabmoduleService {

  constructor(private http: HttpClient, private router: Router) {
    if (Constants.APICONFIG.HOST == 'localhost') {
      this.APIURL = 'http://localhost:3000/v1';
      this.PIVOTALAPIURL = 'http://localhost:3200/api';
    }
  }

  noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
  APIURL = `${Constants.APICONFIG.PROTOCOL}://${Constants.APICONFIG.HOST}:${Constants.APICONFIG.PORT}/v1`;
  PIVOTALAPIURL = `${Constants.APICONFIG.PROTOCOL}://${Constants.APICONFIG.HOST}:${Constants.APICONFIG.PORT}/api`;

  public getLabByDoctorId(req_vars: any): Observable<any> {
    return this.http.post(`${this.APIURL}/getLabByDoctorId`, req_vars);
  }
  public getLabReportsByReqId(req_vars: any): Observable<any> {
    return this.http.post(`${this.APIURL}/getLabReportsByReqId`, req_vars);
  }

  public getRequisitionsByLabId(req_vars: any): Observable<any> {
    return this.http.post(`${this.APIURL}/getRequisitionsByLabId`, req_vars)
  }
  public updateRequisitionByLab(req_vars: any): Observable<any> {
    return this.http.post(`${this.APIURL}/updateRequisitionByLab`, req_vars)
  }

  public LabUploadReport(req_vars: any): Observable<any> {
    return this.http.post(`${this.PIVOTALAPIURL}/v3/LabUploadReport`, req_vars)
  }
  public deleteLabReport(req_vars: any): Observable<any> {
    return this.http.post(`${this.APIURL}/deleteLabReport`, req_vars)
  }
  public getAllLabReportOfPatient(req_vars: any): Observable<any> {
    return this.http.post(`${this.APIURL}/getAllLabReportOfPatient`, req_vars);
  }
public getCustomersFamily(
  req_vars: any
): Observable<any> {

  const token =
    sessionStorage.getItem('token');

  const headers =
    new HttpHeaders()
      .set(
        'Content-Type',
        'application/json'
      )
      .set(
        'Token',
        `${token}`
      );

  return this.http.post<any>(
    `${this.PIVOTALAPIURL}/v2/getFamilyForCustomer`,
    {
      data: req_vars
    },
    {
      headers
    }
  );
}


uploadMediaForMessaging(
  postData: any
): Observable<any> {

  const token =
    sessionStorage.getItem('token');

  const headers =
    new HttpHeaders({
      'Content-Type': 'application/json',
      'Token': token || ''
    });

  return this.http.post<any>(
    `${this.PIVOTALAPIURL}/v3/uploadMediaForMessaging`,
    {
      data: postData
    },
    {
      headers
    }
  );
}

getAllMessageOfConvo(
  doctorId: any,
  patientId: any
): Observable<any> {

  const token =
    sessionStorage.getItem(
      'token'
    );


  const headers =
    new HttpHeaders({

      'Content-Type':
        'application/json',

      'Token':
        token || ''

    });


  const postData = {

    data: {

      DoctorId:
        doctorId,

      PatientId:
        patientId

    }

  };


  console.log(
    'GET CONVERSATION PAYLOAD:',
    postData
  );


  return this.http.post<any>(

    `${this.PIVOTALAPIURL}/v3/getAllMessageOfConvo`,

    postData,

    {
      headers
    }

  );

}


createChatMessage(payload: any): Observable<any> {
  return this.http.post<any>(
    `${this.PIVOTALAPIURL}/v3/createChatMessage`,
    { data: payload },
    {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        token: sessionStorage.getItem('token') || ''
      })
    }
  );
}
}
